

import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { IQueryParams } from "queries";
import helpers from "helpers/index";
import queryClient from 'queries';
import { TypedSeating } from "./seating.query";



export interface TypedTrip_time {
    id?: string | bigint;
    trip_schedule_id?: string | bigint;
    time?: string;
    slug?: string;
    price?: number;
    shipping_price?: number;
    seating_id?: string;
    createdAt?: string | bigint;

    seating?: TypedSeating
}


type IQuery = TypedTrip_time & IQueryParams;


/*
* List of all app
*/
export function useGetTripTimes(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["trip_time/fetch_entity_list"],
        queryFn: () => axios.get<TypedTrip_time[]>(`/trip_time${EndURL}`).then(response => {
            let { data, headers } = response;
            return {
                body: data,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
        retry: 1,
        refetchOnMount: false
    });
}

/** Mutation ... */

export function useMutateGetTripTimes() {
    return useMutation({
        mutationKey: ["trip_time/fetch_entity_list"],
        mutationFn: (object: IQuery) => axios.get<TypedTrip_time[]>(`/trip_time${helpers.buildEndUrl(object)}`).then(response => {
            let { data, headers } = response;
            return {
                body: data,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
    });
}



export function useGetTripTime(trip_template_id: string) {
    return useQuery({
        queryKey: ['trip_time/fetch_entity'],
        queryFn: () => axios.get<TypedTrip_time>(`/trip_time/${trip_template_id}`).then((response) => response.data),
        retry: 1,
        enabled: !!trip_template_id,
    });
}


export function useMutateGetTripTime() {
    return useMutation({
        mutationKey: ['trip_time/fetch_entity'],
        mutationFn: (trip_template_id: any) => axios.get<TypedTrip_time>(`/trip_time/${trip_template_id}`).then((response) => response.data),
    });
}


export function useUpdateTripTime() {
    return useMutation({
        mutationKey: ['trip_time/update_entity'],
        mutationFn: ({ id, ...rest }: TypedTrip_time) => axios.patch<TypedTrip_time>(`/trip_time/${id}`, helpers.cleanEntity(rest)).then((response) => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip_time/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['trip_time/fetch_entity'] });
        }
    });
}


export function useMutateCreateTripTime() {
    return useMutation({
        mutationKey: ['trip_time/create_entity'],
        mutationFn: (entity: TypedTrip_time) => axios.post<TypedTrip_time>(`/trip_time`, helpers.cleanEntity(entity)).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip_time/fetch_entity_list'] });
        }
    });
}

export function useMutateCloneTripTime() {
    return useMutation({
        mutationKey: ['trip_time/clone_entity'],
        mutationFn: (trip_schedule_id: any) => axios.post<TypedTrip_time>(`/trip_time/clone/${trip_schedule_id}`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip_time/fetch_entity_list'] });
        }
    });
}

export function useMutateDeleteTripTime() {
    return useMutation({
        mutationKey: ['trip_time/create_entity'],
        mutationFn: (id: any) => axios.delete<TypedTrip_time>(`/trip_time/${id}`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip_time/fetch_entity_list'] });
        }
    });
}